'use client'

import type { ElementType, MouseEventHandler } from 'react'
import { createElement } from 'react'
import { cx } from './utils/cx'
import type { AccentVar } from './AccentContext'

// `biz` is the reference-library value; `business` is the SnapTransfer
// product name. Both are accepted so app code that speaks in `business`
// doesn't need a local mapping layer.
export type UserTier = 'pro' | 'free' | 'team' | 'biz' | 'business'

const TIER_CLASS: Record<UserTier, string> = {
  pro: 'pro',
  free: 'free',
  team: 'team',
  biz: 'biz',
  business: 'biz'
}

const TIER_LABEL: Record<UserTier, string> = {
  pro: 'pro',
  free: 'free',
  team: 'team',
  biz: 'biz',
  business: 'biz'
}

interface UserChipProps {
  initials: string
  name: string
  tier?: UserTier
  avatarColor?: AccentVar | string
  href?: string
  onClick?: MouseEventHandler
  className?: string
  as?: ElementType
}

export function UserChip({
  initials,
  name,
  tier = 'pro',
  avatarColor = '--mauve',
  href = '#',
  onClick,
  className,
  as = 'a'
}: UserChipProps) {
  return createElement(
    as,
    {
      href,
      onClick,
      className: cx('st-user-chip', TIER_CLASS[tier], className),
      title: 'Account settings'
    },
    <span className="tier">{TIER_LABEL[tier]}</span>,
    <span className="who">
      <span className="avatar" style={{ background: `var(${avatarColor})` }}>
        {initials}
      </span>
      <span>{name}</span>
    </span>
  )
}
